import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { TakingOfInventoryDetail } from "./taking-of-inventory-detail.model";

export class TakingOfInventoryHeader extends EntityBase {
  public InventoryBalancingDate: Date;

  public ShamsiInventoryBalancingDate: string;
  public Number: Number;

  public BranchId: number;

  public BranchCode?: number;

  public BranchTitle: string;

  public BranchLatinTitle: string;

  public WarehouseId: number;

  public WarehouseCode?: number;

  public WarehouseTitle: string;
  public WarehouseLatinTitle: string;

  public StatusKindId: number;

  public StatusKindCode?: number;

  public StatusKindTitle: string;

  public InventoryReceiptVoucherKindId?: number;

  public InventoryReceiptVoucherKindCode?: number;
  public InventoryReceiptVoucherKindTitle: string;

  public InventoryReceiptId?: number;

  public InventoryReceiptNo?: number;

  public InventoryDeliveryVoucherKindId?: number;

  public InventoryDeliveryId?: number;

  public InventoryDeliveryVoucherKindCode?: number;

  public InventoryDeliveryVoucherKindTitle: string;

  public InventoryDeliveryVoucherKindLatinTitle: string;

  public InventoryDeliveryNo?: number;

  public InventoryBalancingKindId: number;

  public InventoryBalancingKindCode?: number;

  public InventoryBalancingKindTitle: string;

  public FiscalYearId: number;

  public Comment: string;

  public TakingOfInventoryDetailList: TakingOfInventoryDetail[];

  public DetailLedgerId?: number;

  public DetailLedgerCode?: number;

  public DetailLedgerTitle: string;
  public HasPricing: boolean;
}
